export const tripPaymentConstants = {
    // Actions
    UPDATE_PREPAY_TYPE: 'UPDATE_PREPAY_TYPE',
    UPDATE_FARE_TOTAL: 'UPDATE_FARE_TOTAL',
    SET_CHARGE_TYPE: 'SET_CHARGE_TYPE',
    CLEAR_TRIP_CHARGE: 'CLEAR_TRIP_CHARGE',

    // Constant Names
    PAYMENT_METHOD_ALL_INCLUSIVE: 'AI',
    PAYMENT_METHOD_BASE_FARE: 'BASE',
    PAYMENT_METHOD_DEFAULT: 'DFLT',

    CHARGE_TYPE_PREPAY: 'PrepayRide',
    CHARGE_TYPE_EXTRA_CHARGE: 'ExtraCharge',

    //Placeholders
    TOLLS_AMOUNT_PLACEHOLDER: 'Tolls Amount',
    MISC_AMOUNT_PLACEHOLDER: 'Misc Amount'
};
